import { useDispatch, useSelector } from "react-redux";
import SharedDiv from "../../Components/SharedDiv/SharedDiv";
import ApplicationInfo from "../../Pages/Submitter/ScientificContributionSubmittedForTheAwardScreen/ApplicationInfo";
import ResearcherScientificCareer from "../../Pages/Submitter/ScientificContributionSubmittedForTheAwardScreen/ResearcherScientificCareer";
import ResearchersIndicators from "../../Pages/Submitter/ScientificContributionSubmittedForTheAwardScreen/ResearchersIndicators";
import SummaryOfTheScientificContribution from "../../Pages/Submitter/ScientificContributionSubmittedForTheAwardScreen/SummaryOfTheScientificContribution/SummaryOfTheScientificContribution.js";
import ButtonAHSF from "../../Components/ButtonAHSF/index.js";
import { UpdateQuestionsAnswersList } from "../../Redux/Reducers/Submitter/QuestionsAnswers/index.js";
import { UpdateSC_NT_RI_ResearcherIndicators } from "../../Redux/Reducers/Submitter/ResearcherIndicators/index.js";
import { UpdateSC_NT_AI_ApplicationInformation } from "../../Redux/Reducers/Submitter/SC_NT_AI_ApplicationInformation/index.js";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useState } from "react";
import { ScientificContributionInformationValidation } from "../../Redux/Reducers/Submitter/ValidationScientificContributionSubmitted/index.js";
import PopupAHSF from "../../Components/PopupAHSF/index.js";
import ValidationView from "../../Components/ValidationView/index.js";

const ScientificContributionSubmittedForTheAward = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const lang = useSelector((state) => state.languageReducer.Language);
  const state = useSelector((state) => {
    return {
      SC_NT_AI_ApplicationInformation:
        state.SC_NT_AI_ApplicationInformation.SC_NT_AI_ApplicationInformation,
      QuestionsAnswers: state.QuestionsAnswers.QuestionsAnswers,
      ResearcherIndicators: state.ResearcherIndicators.ResearcherIndicators,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });
  const [
    PopupComponentValidationViewStatus,
    setPopupComponentValidationViewStatus,
  ] = useState(false);
  const [ValidationResult, setValidationResult] = useState([]);

  const SaveDataPage = async () => {
    const formData = new FormData();

    state.QuestionsAnswers.forEach((item, index) => {
      formData.append(
        `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].questionsAnswersId`,
        item.questionsAnswersId
      );
      formData.append(
        `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].answer`,
        item.answer ?? ""
      );
      formData.append(
        `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].questionTextAr`,
        item.questionTextAr ?? ""
      );
      formData.append(
        `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].questionTextEn`,
        item.questionTextEn ?? ""
      );
      formData.append(
        `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].sorting`,
        item.sorting ?? ""
      );
      formData.append(
        `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].questionsId`,
        item.questionsId ?? ""
      );
      formData.append(
        `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].number`,
        item.number ?? ""
      );
      formData.append(
        `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].attachments`,
        item.attachments ?? ""
      );
      formData.append(
        `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].applicationInformationId`,
        item.applicationInformationId ?? ""
      );
      formData.append(
        `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].numberShowStatus`,
        item.numberShowStatus ?? ""
      );
      formData.append(
        `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].attachmentsShowStatus`,
        item.attachmentsShowStatus ?? ""
      );

      if (item.file) {
        formData.append(
          `sC_NT_RC_QuestionsAnswersUpdateListModels[${index}].file`,
          item.file
        );
      }
    });
    console.log([...formData.entries()], "formData");

    const QuestionsAnswers = await dispatch(
      UpdateQuestionsAnswersList(formData)
    );
    const ResearcherIndicator = await dispatch(
      UpdateSC_NT_RI_ResearcherIndicators(state.ResearcherIndicators)
    );
    console.log(state.SC_NT_AI_ApplicationInformation,"wwwwwwwwwwwwwdwdwd");
    
    const ApplicationInformation = await dispatch(
      UpdateSC_NT_AI_ApplicationInformation(
        state.SC_NT_AI_ApplicationInformation
      )
    );
    if (
      QuestionsAnswers.payload &&
      ResearcherIndicator.payload &&
      ApplicationInformation.payload
    ) {
      return true;
    }
  };

  const closePopupComponentValidationViewStatus = () => {
    // Function to toggle the visibility of the validation popup
    if (PopupComponentValidationViewStatus) {
      setPopupComponentValidationViewStatus(false); // Closing the popup
    } else {
      setPopupComponentValidationViewStatus(true); // Opening the popup
    }
  };

  const SaveAndNext = async () => {
    const saved = await SaveDataPage();
    if (saved == true) {
      var result = await dispatch(
        ScientificContributionInformationValidation({
          applicationInformationId: localStorage.getItem(
            "ApplicationInformationId"
          ),
          lang: lang,
        })
      );
      console.log(result.payload.result.length > 0, "result.payload");
      if (result.payload.result.length > 0) {
        setValidationResult(result.payload.result);
        setPopupComponentValidationViewStatus(true);
      } else {
        navigate("/ResearchersAward/AttachmentsAndDeclarationScreen");
      }
    }
  };
  const disabled = state.ActiveRound;
  return (
    <>
      <SharedDiv
        showTitle={true}
        titleNameEN="Application Information"
        titleNameAR="معلومات الطلب"
        lang={lang}
        buttonComponent={[]}
        showButton={false}
        child={[<ApplicationInfo disabled={disabled} />]}
      />
      <SharedDiv
        showTitle={true}
        titleNameEN=" The researcher's scientific contribution throughout his career"
        titleNameAR=" المساهمة العلمية للباحث على مدار مسيرته"
        lang={lang}
        child={[<ResearcherScientificCareer disabled={disabled} />]}
      />
      <SharedDiv
        showTitle={true}
        titleNameEN="Researchers Indicators"
        titleNameAR="مؤشرات الباحث"
        lang={lang}
        child={[
          <ResearchersIndicators applicationGuid={""} disabled={disabled} />,
        ]}
      />
      <SharedDiv
        showTitle={false}
        titleNameEN="Application Information"
        titleNameAR="تفاصيل الابحاث المقدمة للجائزة في اخر 5 سنوات ونبذة عن المساهمة العلمية"
        lang={lang}
        child={[<SummaryOfTheScientificContribution disabled={disabled} />]}
      />
      {/* <SummaryOfTheScientificContribution disabled={disabled} /> */}
      {!disabled ? (
        <div className="containerButtonMAin">
          <ButtonAHSF
            type={"submitter"}
            fieldsName="PreviousButton"
            lang={lang}
            onClick={() => {
              SaveDataPage();
              navigate("/ResearchersAward/WorkInformationAndAcademic");
            }}
            disabled={false}
            show={true}
          />
          <div className={`SaveButtonMarks ${lang === "ar" ? "rtl" : "ltr"}`}>
            <ButtonAHSF
              type={"submitter"}
              fieldsName="SaveButton"
              lang={lang}
              text="حفظ"
              onClick={() => {
                SaveDataPage(false);
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title:
                    lang != "en"
                      ? "تم حفظ المعلومات بنجاح"
                      : "Saved Successfully",
                  showConfirmButton: false,
                  timer: 1500,
                  // width: "500px",
                });
              }}
              disabled={false}
              show={true}
            />
          </div>

          <ButtonAHSF
            type={"submitter"}
            fieldsName="NextButton"
            lang={lang}
            onClick={() => {
              SaveAndNext();
            }}
            disabled={false}
            show={true}
          />
        </div>
      ) : (
        ""
      )}
      <PopupAHSF
        title={
          lang == "ar"
            ? "يرجى تعبئة الحقول المطلوبة"
            : "Please fill all the required fields"
        }
        componentBody={<ValidationView ValidationList={ValidationResult} />}
        maxWidth="700px"
        maxHeight="800px"
        isPopupOpenStatus={
          PopupComponentValidationViewStatus && ValidationResult.length > 0
        } // Popup open status
        isPopupOpenFunction={closePopupComponentValidationViewStatus} // Function to close the popup
      />
    </>
  );
};

export default ScientificContributionSubmittedForTheAward;
